import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'

export default class Uiuxtemplate extends Component {
  render(){

    const course =[
      {
        title: " Introduction to User Experience (UX)",
        content: [
          "What is UX Design?",
          "Understanding Interaction Design",
          "Principles of User-Centered Design",
          "Role, Requirements, and ROI (Return on Investment)",
          "Process Models in UX Design"
        ]
      },
      {
        title: " Research in UX Design",
        content: [
          "Approaches to Researching User Experiences",
          "Creating Personas and Empathy Mapping",
          "Stakeholder Interviews",
          "Qualitative & Quantitative Research Methods"
        ]
      },
      {
        title: " Analysis in UX Design",
        content: [
          "Competitor Research",
          "User-Centered Research",
          "Analyzing Data and Task Flows",
          "Attributes, Goals, Perspectives & Pain Points",
          "Computer-Human Interaction Principles",
          "Learnsoft.org (Integration with Learning Platforms)"
        ]
      },
      {
        title: " Design Strategy in UX Design",
        content: [
          "Product Ideation",
          "Components and Gestures in Design",
          "Wireframe Sketching (Low Fidelity)",
          "Paper Prototypes and Digital Wireframes",
          "Interaction Design",
          "Designing User Flows",
          "User Journey Mapping",
          "Information Architecture",
          "Laws & Principles of UX",
          "Initial Usability Testing"
        ]
      },
      {
        title: " Usability Testing",
        content: [
          "Testing Methods in UX Design",
          "User Testing Techniques",
          "Advanced Usability Testing Approaches"
        ]
      },
      {
        title: " Case Studies in UX Design",
        content: [
          "Real-world examples and applications",
          "Finalizing a UX Project and Crafting Documentation",
          "Learnsoft.org (Integration with Learning Platforms)"
        ]
      },
      {
        title: "Introduction to User Interface (UI) Design",
        content: [
          "Fundamentals of User Interface Design",
          "Importance in Digital Product Development",
          "Principles of Design"
        ]
      },
      {
        title: "Color Theory and Typography in UI Design",
        content: [
          "Psychology of Colors in UI",
          "Choosing and Pairing Fonts for Readability and Aesthetics"
        ]
      },
      {
        title: " Layout and Composition in UI Design",
        content: [
          "Role of Grid Systems in Layout Design",
          "Creating Visually Appealing and User-Friendly Compositions"
        ]
      },
      {
        title: "Responsive Design in UI Design",
        content: [
          "Designing Interfaces for Various Screen Sizes",
          "Mobile-First Design Principles"
        ]
      },
      {
        title: " UI Components and Patterns",
        content: [
          "Designing Buttons, Forms, Navigation Bars, and UI Elements",
          "Recognizing and Applying Common UI Design Patterns"
        ]
      },
      {
        title: "Interaction Design in UI Design",
        content: [
          "Understanding User Interactions and Feedback",
          "Designing Intuitive and Engaging User Interfaces",
          "Learnsoft.org (Integration with Learning Platforms)"
        ]
      },
      {
        title: "Prototyping and Wireframing",
        content: [
          "Tools and Techniques for Creating Prototypes",
          "Translating Design Concepts into Interactive Wireframes"
        ]
      },
      {
        title: "Design Systems",
        content: [
          "Creating and Maintaining Design Systems for Consistency",
          "Streamlining Design and Development Processes"
        ]
      },
      {
        title: "User Testing in UI Design",
        content: [
          "Conducting Usability Tests for Interface Validation",
          "Iterative Design Based on User Feedback"
        ]
      },
      {
        title: "Microinteractions",
        content: [
          "Enhancing User Experience Through Subtle Animations",
          "Implementing Microinteractions for a Delightful User Journey"
        ]
      },
      {
        title: " Accessibility in UI Design",
        content: [
          "Designing Interfaces Accessible to Users with Diverse Needs",
          "Compliance with Accessibility Standards"
        ]
      },
      {
        title: "UI Trends and Innovations",
        content: [
          "Staying Updated with Current UI Design Trends",
          "Integrating Innovative Design Elements"
        ]
      },
      {
        title: "Portfolio Building",
        content: [
          "Build your Resume",
          "Understanding UX/UI Design Portfolio Best Practices"
        ]
      }
    ]

    const faqData = [
      {
        question: 'What is UI/UX Design Training?',
        answer:
          'UI/UX Design Training is a specialized program aimed at equipping individuals with the skills and knowledge required to design intuitive and user-friendly interfaces for digital products',
      },
      {
        question: 'Why is UI/UX Design Training important?',
        answer:
          'UI/UX Design Training is essential for professionals seeking to create engaging user experiences, improve usability, and enhance overall user satisfaction, leading to the success of digital products and services',
      },
      {
        question: 'Who can benefit from UI/UX Design Training?',
        answer:
          'UI/UX Design Training at the best training centre is suitable for graphic designers, web developers, product managers, marketers, and anyone interested in mastering user-centered design principles',
      },
      {
        question:  `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'After completing a UI/UX Design course, you can pursue roles such as UI/UX Designer, Interaction Designer, User Researcher, Information Architect, and UX/UI Developer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into UI/UX Design at the Best Training Centre. Our comprehensive program warmly welcomes individuals from diverse backgrounds, offering them the opportunity to acquire the skills and knowledge necessary to thrive in the dynamic field of user interface and user experience design. Whether you're a graphic designer, a web developer, or a marketing professional, our courses cater to learners at every level of expertise. With a strong emphasis on creativity and innovation, our expert instructors guide you through essential UI/UX design principles, including user research, wireframing, prototyping, and usability testing. At the Best Training Centre, we prioritize inclusivity and accessibility, ensuring that learners of all backgrounds have the opportunity to excel in mastering UI/UX design with the best training centre. Join us and unlock your potential in UI/UX Design at the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for UI UX Design training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of UI UX Design modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:"UI UX Design, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for UI UX Design reviews."
      },
  ]
  return (
   <>
 {/* <Mainsec title={this.props.title} location1={this.props.location1} img={this.props.url}intro="In the realm of digital design, two indispensable pillars stand tall: User Interface (UI) Design and User Experience (UX) Design. These disciplines are the cornerstone of crafting engaging and seamless interactions with digital products and services. While UI Design concentrates on the visual arrangement and interaction elements, UX Design delves into the holistic user journey, ensuring it is intuitive, efficient, and rewarding."/> */}
 <NewMainsec rating='4.2' students={"297"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the realm of digital design, two indispensable pillars stand tall: User Interface (UI) Design and User Experience (UX) Design. These disciplines are the cornerstone of crafting engaging and seamless interactions with digital products and services. While UI Design concentrates on the visual arrangement and interaction elements, UX Design delves into the holistic user journey, ensuring it is intuitive, efficient, and rewarding."/>

 
 <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		    <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Our UI/UX Design course in ${this.props.location} is meticulously crafted to equip individuals with the essential skills and knowledge required to excel in the dynamic field of User Interface (UI) and User Experience (UX) design. Whether you're a beginner or an aspiring designer looking to enhance your proficiency, this course offers a comprehensive curriculum to meet your learning needs.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={`Elevate your design skills with our comprehensive UI/UX Design Course in ${this.props.location}. Whether you're a beginner or looking to refine your expertise, our course is tailored to provide you with a strong foundation in User Interface (UI) and User Experience (UX) design principles.`}/>
          </section> 
 <Batchtime title={this.props.title} fees="29,999" offer="25,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
 <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Automation Testing" coupath7="automation-testing" cou6='Mean Stack Developer' coupath6='mean-stack-developer' cou4='Python Full Stack Developer' coupath4='python-full-stack-developer' cou='Web design' coupath='web-design' cou3='Web Development' coupath3='web-development'
           cou9='Java Full Stack Developer ' coupath9='java-full-stack-developer' cou1='Software Testing' coupath1='software-testing'
          cou5='Mern stack Developer' coupath5='mern-stack-developer' cou2='Selenium' coupath2='selenium'  cou8='Digital Marketing' coupath8='digital-marketing' />
   </>
  );
}}
